var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyGalleryThankGuest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_19950",
    "data-name": "Gruppe 19950",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 130,
    viewBox: "0 0 114 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25155",
    "data-name": "Rechteck 25155",
    width: 114,
    height: 130,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19856",
    "data-name": "Gruppe 19856",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291206",
    "data-name": "Pfad 291206",
    d: "M27.5,51.75a6.25,6.25,0,1,1,6.25-6.25,6.257,6.257,0,0,1-6.25,6.25m0-11a4.75,4.75,0,1,0,4.75,4.75,4.756,4.756,0,0,0-4.75-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291207",
    "data-name": "Pfad 291207",
    d: "M49.3,92.991H16.5a4.8,4.8,0,0,1-4.75-4.843v-57.3A4.8,4.8,0,0,1,16.5,26.01h60a4.8,4.8,0,0,1,4.75,4.842V52a.75.75,0,0,1-1.5,0V30.852A3.3,3.3,0,0,0,76.5,27.51h-60a3.3,3.3,0,0,0-3.25,3.342v57.3a3.3,3.3,0,0,0,3.25,3.343H49.3a.75.75,0,0,1,0,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291208",
    "data-name": "Pfad 291208",
    d: "M92.3,55.75a.75.75,0,0,1-.75-.75V18.638a3.183,3.183,0,0,0-3.205-3.153H29.023a3.183,3.183,0,0,0-3.2,3.153.75.75,0,0,1-1.5,0,4.685,4.685,0,0,1,4.7-4.653H88.349a4.685,4.685,0,0,1,4.705,4.653V55a.75.75,0,0,1-.75.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291209",
    "data-name": "Pfad 291209",
    d: "M97.064,109.75H61.936a3.19,3.19,0,0,1-3.186-3.186V80.436a3.19,3.19,0,0,1,3.186-3.186H97.064a3.189,3.189,0,0,1,3.185,3.186v26.128a3.189,3.189,0,0,1-3.185,3.186m-35.128-31a1.688,1.688,0,0,0-1.686,1.686v26.128a1.688,1.688,0,0,0,1.686,1.686H97.064a1.687,1.687,0,0,0,1.685-1.686V80.436a1.687,1.687,0,0,0-1.685-1.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291210",
    "data-name": "Pfad 291210",
    d: "M91.1,77.375H89.6V72.623a10.25,10.25,0,0,0-20.5,0v4.752H67.6V72.623a11.75,11.75,0,0,1,23.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291211",
    "data-name": "Pfad 291211",
    d: "M79.5,95.75a1,1,0,0,1-1-1V92h2v2.75a1,1,0,0,1-1,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291212",
    "data-name": "Pfad 291212",
    d: "M79.51,92.25h-.021a2.751,2.751,0,1,1,.021,0m0-4a1.25,1.25,0,0,0-.021,2.5h.021a1.25,1.25,0,0,0,0-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291213",
    "data-name": "Pfad 291213",
    d: "M20,77.792a.75.75,0,0,1-.479-1.327l7.431-6.181a6.767,6.767,0,0,1,8.323-.34,5.381,5.381,0,0,0,6.708-.481l7.959-7.415a6.881,6.881,0,0,1,9.349,0l1.221,1.138a.75.75,0,0,1-1.024,1.1l-1.219-1.137a5.377,5.377,0,0,0-7.3,0l-7.959,7.415a6.9,6.9,0,0,1-8.6.6,5.276,5.276,0,0,0-6.493.273l-7.432,6.18a.741.741,0,0,1-.479.174"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGalleryThankGuest);
export default __webpack_public_path__ + "static/media/empty_gallery_thank_guest.e81714c716653a0a8d030399cfe68616.svg";
export { ForwardRef as ReactComponent };